import { SynagogueIcon } from './SynagogueIcon';

/**
 * author: Google
 * id 9013848A-21D4-4AF4-BA8A-6CF76128FE17
 * name synagogue
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/synagogue.svg
 * tags
 * - Places 
 * - Religion 
 */
export const ShulIcon = SynagogueIcon;
export default ShulIcon